import React, { useEffect, useRef, useState } from "react";
import {
    Paging,
    Pager,
    FilterRow,
    ColumnChooser,
    Column,
    Lookup,
    Export,
    Grouping,
    TotalItem,
    Summary, GroupItem as GroupItemGrid
}
    from 'devextreme-react/data-grid';

import { DataGrid } from 'devextreme-react';
import { Button } from 'devextreme-react/button';
import Form, { SimpleItem, GroupItem, Label, EmptyItem } from 'devextreme-react/form';
import BlockHeader from '../../components/shared/BlockHeader';
import Title from "../../components/shared/Title";
import { formatDate, formatDateTime } from '../../data/app';
import { createStoreLocal } from "../../utils/proxy";
import { cellRender, dataFormatId, toMoney } from "../../utils/common";
import http from "../../utils/http";
import notify from "devextreme/ui/notify";
import { confirm } from 'devextreme/ui/dialog';
const Ejecute = props => {

    const [state, setState] = useState({});
    const [saving, setSaving] = useState(false);
    const [bills, setBills] = useState([]);
    const [loading, setLoading] = useState(true);

    const { id } = props.location.state;
    let refCut = useRef();

    const getInfoCut = async () => {

        const data = await http(`cuts/pre-ejecute/${id}`).asGet();
        const sales = await http(`bills/bills-by-cut/${id}`).asGet();
        const expenses = await http(`expenses/bills-by-cut/${id}`).asGet();

        const { initValue } = data;

        const totalCredito = sales.filter(item => item.paymentTypeId === 2).reduce((previousValue, currentValue) => previousValue + currentValue.totalDetail, 0);
        const totalEfectivo = sales.filter(item => item.paymentTypeId === 1).reduce((previousValue, currentValue) => previousValue + currentValue.totalDetail, 0);
        const totalVentas = totalCredito + totalEfectivo;

        const totalGastos = expenses.reduce((previousValue, currentValue) => previousValue + currentValue.value, 0);

        const endValue = initValue + totalVentas;

        const totalCaja = endValue + totalEfectivo - totalGastos;

        setState({
            ...data,
            initValue,
            totalCredito,
            totalEfectivo,  
            totalVentas,  
            totalGastos,          
            endValue,
            totalCaja,
            status: data.status
        });

        setBills(sales);

        setLoading(false);

    }

    const guardarCut = () => {

        let result = confirm("<i>Esta seguro del  "+title+"?</i>", title);
        result.then((dialogResult) => {
            if (dialogResult){
                setSaving(true);
                http(`cuts/close`).asPost(state).then(resp => {

                    setSaving(false);
                    notify(`Cierre de caja aplicado correctamente`);
                    setState({ ...state, status: true });

                }).catch(err => {
                    setSaving(false);
                    notify(err, 'error', 5000);
                });
            }
        });

    }

    useEffect(() => {
        getInfoCut();
    }, [0]);

    const onCellPrepared = e => {

        const cellsQuantity = ['payoff']

        if (e.rowType == 'data' && e.column.allowEditing) {
            if (cellsQuantity.includes(e.column.dataField))
                if (e.row.data.payoff)
                    e.cellElement.classList.add('pagada');
                else
                    e.cellElement.classList.add('pendiente');

            if (e.column.dataField == 'id')
                e.cellElement.classList.add('col-id-factura');
            if (e.column.dataField == 'reference')
                e.cellElement.classList.add('col-reference-factura');
        }

    }

    const backPage = () => {
        props.history.push('/app/cierres-caja');
    }

    const title = "Cierre de caja";

    const isClosed = state.status;

    return (
        <div className="container">
            {loading ? <div style={{ display: 'flex', justifyContent: 'center'}}>Cargando...</div> :
                <div>
                    <Title title={title} />
                    <BlockHeader title={title} />
                    <DataGrid
                        dataSource={bills}
                        selection={{ mode: 'single' }}
                        showBorders={true}
                        showRowLines={true}

                        allowColumnResizing={true}
                        columnHidingEnabled={true}
                        allowColumnReordering={true}
                        hoverStateEnabled={true}
                        columnAutoWidth={true}
                        onCellPrepared={onCellPrepared}
                        
                    >
                        <Pager allowedPageSizes={[10]} showPageSizeSelector={true} showInfo={true} />
                        <Paging defaultPageSize={10} />
                        <Grouping autoExpandAll={false} />
                        <FilterRow visible={true} />
                        <ColumnChooser enabled={true} />
                        <Export enabled={true} fileName={title} allowExportSelectedData={true} />
                        <Column dataField="id" caption="Factura #" width={90} groupIndex={0} cellRender={dataFormatId} alignment="rigth" />
                        <Column dataField="date" caption="Fecha" dataType='date' format={formatDate} width={120} />
                        <Column dataField="product" caption="Item" allowHeaderFiltering={false} />
                        <Column dataField="paymentTypeId" width={100} caption="Tipo pago">
                            <Lookup disabled={true} dataSource={createStoreLocal({ name: 'billPaymentType' })} valueExpr="id" displayExpr="name" />
                        </Column>
                        <Column dataField="totalDetail" width={110} cellRender={cellRender()} />
                        <Column dataField="createBy" caption='Creado por' width={100} />
                        <Column dataField="createAt" caption='Creado el' dataType='date' format={formatDateTime} width={180} />
                        <Summary>
                            <TotalItem column="totalDetail" summaryType="sum" customizeText={toMoney} />
                            <GroupItemGrid
                                column="totalDetail"
                                summaryType="sum" displayFormat="Total: {0}" alignByColumn={true} />
                        </Summary>
                    </DataGrid>
                    <br />
                    <Form formData={state} ref={refCut}>
                        <GroupItem colCount={6}>
                            <SimpleItem dataField="initValue" colSpan={2} editorOptions={{ readOnly: true }}>
                                <Label text="Saldo Inicial" />
                            </SimpleItem>                           
                            <EmptyItem colSpan={2} />
                            <EmptyItem colSpan={2} />
                            <SimpleItem dataField="totalEfectivo" colSpan={2} editorOptions={{ readOnly: true }}>
                                <Label text="Total Efectivo" />
                            </SimpleItem>
                             <SimpleItem dataField="totalCredito" colSpan={2} editorOptions={{ readOnly: true }}>
                                <Label text="Total Crédito" />
                            </SimpleItem>
                            <SimpleItem dataField="totalVentas" colSpan={2} editorOptions={{ readOnly: true }}>
                                <Label text="Total Ventas" />
                            </SimpleItem>
                            <SimpleItem dataField="totalGastos" colSpan={2} editorOptions={{ readOnly: true }}>
                                <Label text="Gastos Caja Chica" />
                            </SimpleItem>                           
                            <EmptyItem colSpan={4} />
                            <SimpleItem dataField="totalCaja" colSpan={2} editorOptions={{ readOnly: true }}>
                                <Label text="Total Caja" />
                            </SimpleItem>
                        </GroupItem>
                    </Form>
                    <br />
                    <Button
                        text={`Regresar`}
                        type="normal"
                        icon="chevronleft"
                        stylingMode="contained"
                        className="m-1"
                        disabled={saving}
                        onClick={backPage}
                    />
                    <Button
                        text={`${saving ? 'Guardando...' : 'Cerrar caja'}`}
                        type="default"
                        icon="save"
                        stylingMode="contained"
                        className="m-1"
                        disabled={saving || isClosed}
                        onClick={guardarCut}
                    />
                </div>
            }

        </div>
    )


}


export default Ejecute;
